let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("54BEG")).then(() => parcelRequire('aslEf'));